<template>
    <div class="bubble" :class="[angle,type]" >
        <slot></slot>
    </div>
</template>

<script>
	export default {
		name: "Bubble",
        props: ["angle","type"]
	}
</script>

<style lang="scss" scoped>
    .bubble{
        display: block;
        background: $white;
        padding: 25px;
        border-radius: 20px;
        width: 200px;
        position: absolute;
        font-size: 14px;
        box-shadow: 0px 2px 5px rgba(0,0,0,0.5);
        &.big{
            width: 90vw;
            max-width: 330px;
            text-align: center;
            padding: 35px 25px;
        }
        &.bottom{
            &:before{
                display: block;
                content: "";
                position: absolute;
                bottom: -32px;
                right: 30%;
                width: 0;
                height: 0;
                border-left: 20px solid transparent;
                border-right: 5px solid transparent;
                border-top: 27px solid $dark;
                filter: blur(3px);
                opacity: 0.5;
            }
            &:after{
                display: block;
                content: "";
                position: absolute;
                bottom: -29px;
                right: 30%;
                width: 0;
                height: 0;
                border-left: 20px solid transparent;
                border-right: 5px solid transparent;
                border-top: 30px solid $white;
            }
        }
        &.right{
            &:before{
                display: block;
                content: "";
                position: absolute;
                top: 50%;
                right: -23px;
                width: 0;
                height: 0;
                border-top: 10px solid transparent;
                border-bottom: 5px solid transparent;
                border-left: 17px solid $dark;
                filter: blur(3px);
                opacity: 0.5;
            }
            &:after{
                display: block;
                content: "";
                position: absolute;
                top: 50%;
                right: -20px;
                width: 0;
                height: 0;
                border-top: 10px solid transparent;
                border-bottom: 5px solid transparent;
                border-left: 20px solid $white;
            }
        }
    }
</style>
